import React from "react";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";

function WhoWeAre() {
    return (
        <div className="landing-page-component">
            <FrontHeader />
            <div className="page-content pb-5">
                <div className="container-easy-market">
                    <div className="container">
                        {/* Titre principal */}
                        <h1 className="about-us-main-title">
                            Qui sommes-nous ?
                        </h1>

                        {/* Première section : Image + Texte */}
                        <div className="about-us-section">
                            <div className="row align-items-center">
                                {/* Image à gauche */}
                                <div className="col-md-6 col-lg-5">
                                    <div className="about-us-image-container">
                                        <img 
                                            src="/Yesshop Contact.png" 
                                            alt="AMILINK - Qui sommes-nous"
                                            className="about-us-image"
                                        />
                                    </div>
                                </div>

                                {/* Texte à droite */}
                                <div className="col-md-6 col-lg-7">
                                    <div className="about-us-content">
                                        <p className="about-us-subtitle">
                                            QUI SOMMES-NOUS
                                        </p>
                                        <h2 className="about-us-brand-name">
                                            YES SHOP
                                        </h2>
                                        <div className="about-us-description">
                                            <p>
                                                <strong>YES SHOP</strong> est une marketplace moderne qui met en
                                                relation vendeurs et acheteurs à travers une plateforme
                                                100 % digitale.
                                                <br />
                                                Notre objectif est de faciliter l’achat en ligne en offrant des
                                                produits variés, un service rapide et une expérience sécurisée.
                                            </p>
                                            <p>
                                                <strong>YES SHOP</strong> est un produit de Yobante Express,
                                                <br />
                                                un écosystème dédié au commerce, à la logistique et à la
                                                digitalisation des services au Sénégal.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section Nos valeurs */}
                        <div className="about-us-values-section">
                            <h3 className="about-us-values-title">
                                Valeur
                            </h3>
                            <ul className="about-us-values-bullets">
                                <li>
                                    <strong>Fiabilité</strong> : assurer un service sécurisé et transparent.
                                </li>
                                <li>
                                    <strong>Accessibilité</strong> : rendre l’achat en ligne simple pour tous.
                                </li>
                                <li>
                                    <strong>Rapidité</strong> : livraison rapide et traitement efficace des commandes.
                                </li>
                                <li>
                                    <strong>Innovation</strong> : proposer des solutions modernes et adaptées au marché.
                                </li>
                                <li>
                                    <strong>Satisfaction client</strong> : placer l’expérience client au cœur de notre travail.
                                </li>
                            </ul>
                        </div>

                        {/* Section Notre équipe */}
                        <div className="about-us-team-section">
                            <div className="about-us-team-header">
                                <div className="about-us-team-header-line"></div>
                                <p className="about-us-team-subtitle">
                                    QUI SOMMES-NOUS
                                </p>
                                <h3 className="about-us-team-title">
                                    Notre équipe
                                </h3>
                            </div>
                            <div className="about-us-team-members">
                                {[
                                    {
                                        name: "Badra Badji",
                                        role: "Fondateur / Directeur général",
                                    },
                                    {
                                        name: "Ndeye Astou Gaye",
                                        role: "Community Manager",
                                    },
                                    {
                                        name: "Abdourahmane Diallo",
                                        role: "Community Manager",
                                    },
                                    {
                                        name: "Angelique Codou Bassene",
                                        role: "Responsable Logistique",
                                    },
                                    {
                                        name: "Binta Sagna",
                                        role: "Chargé clientèle",
                                    },
                                ].map((member) => (
                                    <div className="about-us-team-card" key={member.name}>
                                        <div className="about-us-team-photo-placeholder"></div>
                                        <h4 className="about-us-team-name">{member.name}</h4>
                                        <p className="about-us-team-role">{member.role}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section Mot du fondateur */}
                        <div className="about-us-founder-section">
                            <div className="about-us-founder-header">
                                <p className="about-us-founder-subtitle">
                                    QUI SOMMES-NOUS
                                </p>
                                <div className="about-us-founder-title-container">
                                    <div className="about-us-founder-header-line"></div>
                                    <h3 className="about-us-founder-title">
                                        Mot du fondateur
                                    </h3>
                                </div>
                            </div>
                            <div className="about-us-founder-quote-card">
                                <blockquote className="about-us-founder-quote">
                                    « Avec YES SHOP, notre vision est claire : permettre à tous les commerçants qu’ils soient artisans, vendeurs de quartier, boutiques établies ou marques internationales d’accéder à un commerce digital moderne et sans frontières.
                                    <br />
                                    YES SHOP est conçu pour simplifier la vente, renforcer la visibilité et connecter les commerçants aux clients du monde entier.
                                    <br />
                                    Notre ambition est de créer une plateforme où chaque vendeur peut grandir, innover et saisir de nouvelles opportunités dans un marché global. »
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default WhoWeAre;